import { render } from "./ResumeList.vue?vue&type=template&id=a809d764&scoped=true"
import script from "./ResumeList.vue?vue&type=script&lang=js"
export * from "./ResumeList.vue?vue&type=script&lang=js"

import "./ResumeList.vue?vue&type=style&index=0&id=a809d764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a809d764"]])

export default __exports__